// extracted by mini-css-extract-plugin
module.exports = {"table-actions-wrapper":"TableActions_table-actions-wrapper__wswQO"};